import AppRouter from "./routing";

function App() {
  return <AppRouter />;
}

export default App;
